import { Button, Icon } from "@outschool/backpack";
import { faChartSimpleRegular } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

import { MINIMUM_NUMBER_OF_CLASSES_TO_COMPARE } from "./consts";

interface CompareButtonProps {
  isComparing: boolean;
  selectedListings: string[];
  onClickCompare: () => void;
}

export default function CompareButton({
  isComparing,
  selectedListings,
  onClickCompare,
}: CompareButtonProps) {
  const { t } = useTranslation(
    "client\\components\\classComparison\\CompareButton",
  );

  return (
    <Button
      variant={isComparing ? "contained" : "outlined"}
      color={isComparing ? "primary" : "neutral"}
      startIcon={<Icon icon={faChartSimpleRegular} />}
      onClick={onClickCompare}
      disabled={
        isComparing &&
        selectedListings.length < MINIMUM_NUMBER_OF_CLASSES_TO_COMPARE
      }
    >
      {selectedListings.length > 0
        ? t("Compare ( {{numberOfClassesSelected}} )", {
            numberOfClassesSelected: selectedListings.length,
          })
        : t("Compare")}
    </Button>
  );
}

export function CancelCompareButton({
  onClickCancel,
}: {
  onClickCancel: () => void;
}) {
  const { t } = useTranslation(
    "client\\components\\classComparison\\CompareButton",
  );
  const isMobile = useIsMobile();

  return (
    <Button
      variant={isMobile ? "text" : "link"}
      color="primary"
      onClick={onClickCancel}
    >
      {t("Cancel")}
    </Button>
  );
}
